import React, { Component } from 'react';
import '../assets/custom.css';
import REST from '../Shared/REST';
import DialogBox from "../Shared/DialogBox";
import Header from "../HomeHeaderComponent/HomeHeader";
import icon_twitter from "../assets/images/Twitter_Social_Icon.png";
import icon_fackbook from "../assets/images/Facebook_logo.png";

var logoIdeasThatWork = require('../assets/images/logo_ideasthatwork.png');

export default class HelpComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstName: '', lastName: '', eMail: '', reason: '', done:false, warning: '', errorEmail: '', confirmEmail: '', errorConfirmEmail:'', emailMatch: false, modalDialog: false, responseContent:'' };
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleReason = this.handleReason.bind(this);
        this.handleHelp = this.handleHelp.bind(this);
        this.handleEmailConfirmChange = this.handleEmailConfirmChange.bind(this);
    }

    handleFirstName(event) {
        this.setState({ firstName: event.target.value });
    }

    handleLastName(event) {
        this.setState({ lastName: event.target.value });
    }

    handleEmail(event) {
        this.setState({eMail: event.target.value});
        if (!this.validateEmail(event.target.value)){
            this.setState({eMail: '', errorEmail: 'validationRed', warning: 'Email address format is invalid' });
        }
        else {
            this.setState({eMail: event.target.value, warning: '', errorEmail: ''});
        }
    }

    handleEmailConfirmChange(event){
        this.setState({confirmEmail: event.target.value});
        if(this.validateEmail(event.target.value) && this.validateEmail(this.state.eMail)){
            if(event.target.value === this.state.eMail){
                this.setState({confirmEmail: event.target.value, errorEmail: '', errorConfirmEmail: '', warning: '', emailMatch: true});
            }
            else{
                this.setState({confirmEmail: event.target.value, errorEmail: 'validationRed', errorConfirmEmail: 'validationRed', warning: 'Emails Do Not Match!', emailMatch: false });
            }
        }
        else {
            this.setState({confirmEmail: '', errorEmail: 'validationRed', errorConfirmEmail: 'validationRed', warning: 'Email address format is invalid', emailMatch: false });
        }
    }

    handleReason(event) {
        this.setState({ reason: event.target.value });
    }

    handleHelp(event) {
        REST.helpRequest(this.state).then((response) => {
            this.setState({
                modalDialog: true,
                responseContent:'Help request sent. You will receive a response once an admin has reviewed the application.'
            });
            //setTimeout(()=>{this.setState({modalDialog:false})},5000);
            this.setState({
                done:true
            });
        }).catch((error) => {
            console.log('Error Request Account', error);
            this.setState({
                modalDialog: true,
                responseContent:'Error Request Account'
            });
            //setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        event.preventDefault()
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate(){
        let valid = true;
        let fields = this.state;
        if(fields.firstName === '' || fields.lastName === '' || fields.reason === '' || !this.validateEmail(this.state.eMail)){
            valid = false;
        }
        return valid;
    }

    render() {
        return (
            <div>
                <Header currentItem = {"Help"}/>

                <div className="clearfix"></div>

                <div className="section bgGreen">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1>Having a problem?</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 bgGrey roundCorners">
                                <h2 style={{marginTop:15}}>FILL OUT THE FORM. We’ll get back to you ASAP.</h2>
                                <form className="formHelp">
                                    <label htmlFor="inputFirstName" className="sr-only">First Name</label>
                                    <input onChange={this.handleFirstName} type="text" id="inputFirstName" className="form-control w100" placeholder="First Name" required autoFocus />
                                    <label htmlFor="inputLastName" className="sr-only">Last Name</label>
                                    <input type="text" id="inputLastName" onChange={this.handleLastName} className="form-control w100" placeholder="Last Name" required />
                                    <div id={"validWarning"} style={{color:'red'}}>{this.state.warning}</div>
                                    <label htmlFor="inputEmail" className="sr-only">Email Address</label>
                                    <input onBlur={this.handleEmail} type="email" id="inputEmail" className={this.state.errorEmail + ' form-control w100'} placeholder="Email Address" required />
                                    <input type="email" id="inputConfirmEmail" className={this.state.errorConfirmEmail + ' form-control w100'} onBlur={this.handleEmailConfirmChange} placeholder="Confirm Email Address" required />
                                    <textarea onChange={this.handleReason} placeholder="Tell us what's going on." required className="form-control w100"></textarea>
                                    <button disabled={!this.validate() || this.state.done} onClick={this.handleHelp} className="btn btn-primary btn-block" type="submit" style={{textAlign:'center'}}>Submit</button>

                                </form>
                            </div>
                            <div className="col-md-6">

                            </div>
                        </div>
                    </div>
                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                </div>

                <footer className="bgGrey">
                    <div className="container">
                        <div className="row" style={{marginBottom:25}}>
                            <div className="col-sm-2" style={{textAlign:'left'}}>
                                <b>Follow us: </b>
                            </div>
                            <div className="col-sm-10" style={{textAlign:'left'}}>
                                <div style={{marginTop:1, marginLeft: -30}}>
                                    <a href={"https://twitter.com/AvenuePM"} style={{ textDecoration: 'none' }} target="_blank">
                                        <img src={icon_twitter} style={{width:28, height:28}} alt="" border="0" /> Twitter
                                    </a>
                                </div>
                                <div style={{marginLeft:95, marginTop:-28}} >
                                    <a href={"https://www.facebook.com/profile.php?id=100009224578527&lst=100006500830477%3A100009224578527%3A1587693428&sk=timeline"} style={{ textDecoration: 'none' }} target="_blank">
                                        <img src={icon_fackbook} style={{width:28, height:28}} alt="" border="0" /> Facebook
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <p>This document was produced under U.S. Department of Education, Office of Special Education Programs Grant No. H327S170012. The views  expressed herein do not necessarily represent the positions or polices of the Department of Education. No official endorsement by the U.S. Department of Education of any product, commodity, service or enterprise mentioned in this publication is intended or should be inferred. This product is public domain.  Authorization to reproduce it in whole or in part is granted. While permission to reprint this publication is not necessary, the citation should be.</p>
                                <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the University of Minnesota and Penn State University.</p>
                                <img src={logoIdeasThatWork} alt="Logo - Ideas That Work. U.S. Office of Special Education Programs" border="0" />
                            </div>
                        </div>
                    </div>
                </footer>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/HelpComponent/Help.js